import { render, staticRenderFns } from "./AddAgentBots.vue?vue&type=template&id=0a0bdf0f&"
import script from "./AddAgentBots.vue?vue&type=script&lang=js&"
export * from "./AddAgentBots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports